/* 販売期間（2026-10-13）— 商品ごとに「販売開始日時」「販売終了日時」を決め、期間外は購入できなくする
 *
 *  設定: 管理画面の商品ページ下「メタフィールド」の 販売開始日時（custom.sale_start）・販売終了日時（custom.sale_end）。
 *        片方だけでもよい（開始だけ＝その日時から販売／終了だけ＝その日時まで販売）。空なら今までどおり常に販売。
 *  ページは期間外も表示したまま、購入ボタン等だけを止める。
 *  Liquid 側でも表示時点の状態で出しておき（JS が動かなくても止まる）、ここで閲覧中の時刻で判定し直す。
 *  ページを開いたまま開始・終了の時刻をまたいだときも、その時刻に切り替える。
 *
 *  使い方: 対象の要素に data-sale-start / data-sale-end（UNIX 秒。snippets/kinujo-sale-period.liquid が出す）を付け、
 *          kjSalePeriod.watch(要素の配列, function (要素, 状態) {...}) で受け取る。状態は 'before' | 'open' | 'after'
 *  ※ 画面で止めるだけの仕組み。カートへの追加・購入手続きを Shopify 側で完全に止めるものではない
 */
(function () {
  // 動作確認用（2026-10-14）：公開中ではないテーマのプレビューに限り、URL に ?kj_now=2026-10-19T09:00 を付けると
  // その日時（日本時間）として判定する。公開中のテーマ（Shopify.theme.role が main）では無視する
  var fakeNow = null;
  try {
    var m = /[?&]kj_now=([^&]+)/.exec(location.search);
    if (m && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') {
      var t = Date.parse(decodeURIComponent(m[1]) + (/[zZ]|[+-]\d\d:?\d\d$/.test(m[1]) ? '' : '+09:00'));
      if (!isNaN(t)) fakeNow = t - Date.now();
    }
  } catch (e) {}
  function clock() { return Date.now() + (fakeNow || 0); }

  function parse(v) {
    return v && /^\d+$/.test(v) ? parseInt(v, 10) * 1000 : null;
  }

  function state(el, now) {
    var start = parse(el.getAttribute('data-sale-start'));
    var end = parse(el.getAttribute('data-sale-end'));
    now = now || clock();
    if (start !== null && now < start) return 'before';
    if (end !== null && now >= end) return 'after';
    return 'open';
  }

  // 次に状態が変わる時刻（なければ null）
  function nextChange(els, now) {
    var next = null;
    els.forEach(function (el) {
      [parse(el.getAttribute('data-sale-start')), parse(el.getAttribute('data-sale-end'))].forEach(function (t) {
        if (t !== null && t > now && (next === null || t < next)) next = t;
      });
    });
    return next;
  }

  function watch(els, apply) {
    els = Array.prototype.slice.call(els).filter(function (el) {
      return el.hasAttribute('data-sale-start') || el.hasAttribute('data-sale-end');
    });
    if (!els.length) return;
    var timer = null;
    function run() {
      var now = clock();
      els.forEach(function (el) {
        var s = state(el, now);
        el.setAttribute('data-sale-state', s);
        apply(el, s);
      });
      clearTimeout(timer);
      var next = nextChange(els, now);
      // setTimeout は約24.8日を超えると即時に発火するため、長いときは1日ごとに見直す
      if (next !== null) timer = setTimeout(run, Math.min(next - now + 500, 86400000));
    }
    run();
    // スリープ復帰や別タブから戻ったときはタイマーが遅れるので、表示のたびに判定し直す
    document.addEventListener('visibilitychange', function () { if (!document.hidden) run(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) run(); });
  }

  window.kjSalePeriod = { state: state, watch: watch };
})();
